<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-12 col-12">
                <div class="form-group">
                    <label for="equipment">Equipment</label>
                    <wj-combo-box
                        [(ngModel)]="target.equipment"
                        name="equipment"
                        id="equipment"
                        [isRequired]="false"
                        [itemsSource]="equipmentMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-12">
            <div class="form-group">
                <label for="mechanicHrRef">Mechanic</label>
                <wj-combo-box
                    [(ngModel)]="target.mechanicHrRef"
                    name="mechanicHrRef"
                    id="mechanicHrRef"
                    [itemsSource]="mechanicMap"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    [isRequired]="false"
                ></wj-combo-box>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="date">Occurrence Date</label>
                    <wj-input-date [(ngModel)]="target.date" name="date" id="date" [isRequired]="false"></wj-input-date>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="workOrder">Work Order</label>
                    <input type="text" class="form-control" [(ngModel)]="target.workOrder" name="workOrder" id="workOrder" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="description">Description</label>
                    <textarea rows="3" class="form-control" [(ngModel)]="target.description" name="description" id="description"></textarea>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <button id="btnPhoto" type="button" class="btn btn-secondary" style="width: 100%" (click)="fileInput.click()">
                        <fa-icon class="d-none d-sm-inline-block" [icon]="faCamera"></fa-icon> Take a Photo
                    </button>
                    <input #fileInput style="display: none" type="file" (change)="onFileChanged($event)" accept="image/*" multiple />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <button id="btnVideo" type="button" class="btn btn-secondary" style="width: 100%" (click)="videoInput.click()">
                        <fa-icon class="d-none d-sm-inline-block" [icon]="faVideo"></fa-icon> Upload a Video (.mp4)
                    </button>
                    <input #videoInput style="display: none" type="file" (change)="onFileChangedVideo($event)" accept=".mp4" multiple />
                </div>
            </div>
        </div>
        @if (false) {
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <video class="video" style="width: 100%" #video autoplay controls></video>
                    </div>
                </div>
            </div>
        }
        @if (target.imageUrls && target.imageUrls.length > 0) {
            <div class="row">
                <div class="col-12">
                    <h5>Images/Videos</h5>
                </div>
                @for (url of target.imageUrls; track url) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        @if (canShowImage(url)) {
                            <img style="width: 100%" [src]="'./Resources/Images/EquipmentBreakdown/' + url + '?w=300'" />
                        }
                        @if (canShowVideo(url)) {
                            <video controls style="width: 100%" [src]="'./Resources/Images/EquipmentBreakdown/' + url"></video>
                        }
                    </div>
                }
            </div>
        }
        @if (images && images.length > 0) {
            <div class="row">
                <div class="col-12">
                    <h5>Images To Upload</h5>
                </div>
                @for (image of images; track image) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <div class="close-x" (click)="removeImage(image)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        <img style="width: 100%" [src]="image.url" />
                    </div>
                }
            </div>
        }
        @if (videos && videos.length > 0) {
            <div class="row">
                <div class="col-12">
                    <h5>Videos To Upload</h5>
                </div>
                @for (video of videos; track video) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <div class="close-x" (click)="removeVideo(video)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        <video controls style="width: 100%" [src]="video.previewSrc"></video>
                    </div>
                }
            </div>
        }

        @if (progress > 0 && progress < 100) {
            <div class="row">
                <div class="col-12">
                    <div class="progress">
                        <div
                            class="progress-bar"
                            role="progressbar"
                            [ngStyle]="{ 'width.%': progress }"
                            aria-valuenow="25"
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >
                            {{ progress }}%
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
